import { Dialog, DialogTitle, DialogContent, Button, Box } from "@mui/material";

export default function PDFViewerDialog({ open, onClose, url }) {

  const downloadFile = async (url) => {
    const response = await fetch(url);
    const arrayBuffer = await response.arrayBuffer();
    const blob = new Blob([arrayBuffer], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    const filename = response.headers
      .get("Content-Disposition")
      .split("filename=")[1]
      .replace(/"/g, "");

    a.download = filename;
    a.href = blobUrl;
    document.body.appendChild(a);
    a.click();
    a.remove();

    URL.revokeObjectURL(blobUrl);
  };

  const handlePrint = async () => {
    if (!url) return;

    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (isSafari) {
      const printWindow = window.open("", "_blank", "width=600,height=800");
      if (!printWindow) {
        alert("Safari a bloqué la fenêtre d'impression. Veuillez autoriser les pop-ups pour ce site");
        return;
      }

      printWindow.location.href = blobUrl;

      const interval = setInterval(() => {
        try {
          printWindow.print();

          setTimeout(() => {
            try {
              printWindow.close();
            } catch (e) {}
          }, 500);

          clearInterval(interval);
        } catch (e) {}
      }, 150);

      return;
    }

    const iframe = document.createElement("iframe");
    iframe.style.position = "fixed";
    iframe.style.right = 0;
    iframe.style.bottom = 0;
    iframe.style.width = 0;
    iframe.style.height = 0;
    iframe.style.border = "none";
    iframe.src = blobUrl;

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      setTimeout(() => {
        URL.revokeObjectURL(blobUrl);
        iframe.remove();
      }, 500);
    };

    document.body.appendChild(iframe);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Document PDF</DialogTitle>

      <DialogContent dividers>
        {url && (
          <iframe
            src={url}
            width="100%"
            height="600px"
            title="pdf-viewer"
            style={{ border: "none" }}
          />
        )}
      </DialogContent>

      <Box sx={{ display: "flex", justifyContent: "flex-end", p: 2, gap: 1 }}>
        <Button variant="outlined" onClick={() => downloadFile(url)}>
          Télécharger
        </Button>

        <Button variant="outlined" onClick={handlePrint}>
          Imprimer
        </Button>

        <Button variant="contained" onClick={onClose}>
          Fermer
        </Button>
      </Box>
    </Dialog>
  );
}
